// extracted by mini-css-extract-plugin
module.exports = {"nav":"nav-37sxGLGQ","navbox":"navbox-VpshfeGJ","item":"item-14FE-BHs","link":"link-tTyy6LOh","more":"more-2cYESJWQ","turn":"turn-1cztvxsr","redHot":"redHot-TMQVkdJy"};